<div class="breadcrumbs">
    <div class="breadcrumbs-container">
        <section class="breadcrumbs">
            <div class="breadcrumbs-item" *ngFor="let item of breadcrumbItems; let i = index">
                <p *ngIf="(i < breadcrumbItems.length - 1)">{{item.name}} <i class="fad fa-chevron-right"></i></p>
                <p class="last" *ngIf="i === breadcrumbItems.length - 1">{{item.name}}</p>
            </div>
        </section>
    </div>
</div>